import React, {Component} from 'react';
import PropTypes from "prop-types";
import {withRouter} from 'react-router-dom';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
import {BeatLoader} from 'react-spinners';
import {_addNotification,_addNotificationError} from '../../../server/util';
import {get,postWithHeaders,patch} from "../../../server/actions";
import ReactTable from 'react-table';
import '../../../../src/assets/css/react-table.css';
import _ from 'lodash';
import { date_format } from '../../../server/constants';
var converter = require('number-to-words');
let schoolId=0;
class BCACHistory extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            applications:[],
            columns:[],
            enrollmentHistory:[],
            schoolObject:[],
            sid:'',
            pkgRegStudents:[], 
        }
       
        this.getColumns = this.getColumns.bind(this);
    }
    componentWillMount=()=>{
        this.setState({columns:this.getColumns()});
        const {schoolObject,sid,pkgRegStudents} = this.context.router.route.location.state;
        console.log(schoolObject,sid,pkgRegStudents)
        this.setState({schoolObject,sid,pkgRegStudents})
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
        this.getEnrollmentInfo();
        
    }
    getEnrollmentInfo = () =>{
        this.setState({loading: true});
        const {schoolObject}=this.state;
        const sessionYear=schoolObject.sessionYear||{}
        let parentEmail=  sessionStorage.getItem('loggedInUserInfo');
         const startDate = moment(sessionYear.sessionStartDate).startOf("isoWeek").format("YYYY-MM-DD")
        const endDate = moment(sessionYear.sessionEndDate).startOf('isoWeek').add('days',4).format("YYYY-MM-DD")
         get(`/${this.state.sid}/enrollments?startDate=${startDate}&endDate=${endDate}&isSummary=false&parentEmail=${parentEmail}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({enrollmentHistory:(data.response||[]),loading:false})
        }).catch(error => {
            this.setState({loading: false, enrollmentHistory:[]});
            console.log("Loading Report Failed", error)
        })
    }
    getColumns=()=>{
        let columns = [];
            columns.push({
                Header: 'Name',
                accessor: 'name',
                style: { textAlign: 'center' },
            });
            columns.push({
                Header: 'Type',
                accessor: 'type',
                style: { textAlign: 'center' },
               
            });
            columns.push({
                Header: 'Enrolled On',
                accessor: 'enrolledOn',
                style: { textAlign: 'center' },
               
            });
            columns.push({
                Header: 'Start Date',
                accessor: 'startDate',
                style: { textAlign: 'center' },
                
            });
            columns.push({
                Header: 'End Date',
                accessor: 'endDate',
                style: { textAlign: 'center' },
                
            });
            columns.push({
                Header: 'Payment',
                accessor: 'payment',
                style: { textAlign: 'center' },
                
            });
            columns.push({
                Header: 'Payment Type',
                accessor: 'paymentType',
                style: { textAlign: 'center' },
                
            });
            columns.push({
                Header: 'Amount',
                accessor: 'amount',
                style: { textAlign: 'center' },
                
            });
            
            return columns;
        }
  /*   nextPath(path) {
        this.props.history.push(path);
      } */
    render(){
       
        return(<div>
            <NotificationSystem ref="notificationSystem"/>
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
            <div className="container">          
            <div className="row">
                <div className="sectionTitle">
                        <h2>
                            {<span>BC&AC Enrollment History</span>}
                        </h2>
                        <button className="pull-right btn btn-xs bg-color-4" style={{margin:'0px',color:'#ffffff',marginBottom:'10px'}} onClick={(e) => {
                                        e.preventDefault();
                                        let _self=this;
                                        _self.context.router.history.goBack() ;
                                    }}><i className="fa fa-arrow-circle-left" aria-hidden="true"></i> Back to home</button>
                        </div>
                       
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive">
                        <section className="clearfix">
                            <div className="tab-content">
                                <div className="media">
                                    <div className="panel panel-primary">
                                        <div className="panel-body">    
                                        <ReactTable  
                                            data={this.state.enrollmentHistory}                                                                          
                                            columns={this.state.columns}
                                            minRows={10}
                                            className="-striped -highlight"
                                            noDataText='No data found'
                                            showPagination={false}
                                        />
                                           <div className="pull-right"> 
                                                    <button onClick={() => { 
                                                        this.props.history.push({
                                                            pathname: '/parent/bcac',
                                                            state: {
                                                                schoolObject:this.state.schoolObject,
                                                                sid:this.state.sid,
                                                                pkgRegStudents:this.state.pkgRegStudents, 
                                                            }
                                                            
                                                        });
                                                    }}
                                                        className="btn button-xs btn-success bg-color-1"
                                                    >Enroll</button>
                                                    </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        </div>)
    }
}
BCACHistory.contextTypes = {
    router: PropTypes.object.isRequired
}
export default withRouter(BCACHistory)



// WEBPACK FOOTER //
// ./src/components/Parent/bcac/bcacHistory.jsx